import React, {Component} from 'react';

import BiaxialLineChart from './BiaxialLineChart2.js';


class ContractChart extends Component {

    constructor(props) {
        super(props);
        this.state = {
            year : this.props.year,
            chatData : null
        }
    }

    componentWillReceiveProps = (nextProps) => {
        
        this.setState({
            year : nextProps.year,
            chartData : nextProps.chartData
        })
    }


	render() {
        
        if (this.state.chartData == null) {
            return (
                <div className="card border-top border-3 border-top-primary">
                    <div className="card-header d-flex" style={{ padding: "5px 20px"}}>
                        <h5 className="card-header-title">계약</h5>
                    </div>
                    <div className="card-body" style={{height:this.props.height + "px", textAlign:"center", paddingTop:"50px"}}>
                        <span className="dashboard-spinner spinner-xxl"></span>
                    </div>
                </div>
            )
        } else if(this.state.chartData.length == 0) {
            return (
                <div className="card border-top border-3 border-top-primary">
                    <div className="card-header d-flex" style={{ padding: "5px 20px"}}>
                        <h5 className="card-header-title">계약</h5>
                    </div>
                    <div className="card-body" style={{height:this.props.height + "px", textAlign:"center", paddingTop:"50px"}}>
                        No Data
                    </div>
                </div>
            )
        } else {
    		return(
    			<div className="card border-top border-3 border-top-primary">
                    <div className="card-header d-flex" style={{ padding: "5px 20px"}}>
                        <h5 className="card-header-title">계약</h5>
                    </div>
                    <div className="card-body" style={{height:this.props.height + "px"}}>
                        <BiaxialLineChart data={this.state.chartData} year={this.state.year} yearChangeFn={this.props.yearChangeFn}/>
                    </div>
                </div>
    		)
        }
	}

}

export default ContractChart;